
<div class="coupon-container">

    <div class="coupon-item" [ngClass]="{'active': isChecked,}">

      <!-- <div *ngIf="validation()" class="box-disabled" (click)="openCanva()">
          <div class="icon-lock"></div>
      </div> -->

      <div class="coupon-left" >
          <div class="icon-wrapper">
              <div class="icon-wallet"></div>
          </div>
          <div class="coupon-info" >
              <span class="coupon-title">
                  Cashback
              </span>
              <span class="coupon-subtitle" *ngIf="!selectedOption.checked">
                  Você tem <span class="highlight-value">{{ user.cashback | currency:'BRL' }}</span> de cashback.
              </span>
              <span class="coupon-subtitle" style="color: #09a509;" *ngIf="selectedOption.checked">
                  Você está utilizando <span class="highlight-value" style="color: #09a509;">{{ selectedOption.value | currency:'BRL' }}</span> de cashback.
              </span>
          </div>
      </div>
      
      <label class="toggle-switch">
          <input type="checkbox" [checked]="selectedOption.checked" (click)="selectOption($event)">
          <span class="slider"></span>
      </label>

    </div>
</div>


<div class="box-off-canva" [ngClass]="{'open': this.openInfo}" (click)="closeOffCanvas()"></div>
<div class="offcanvas offcanvas-bottom" tabindex="-1" [ngClass]="{'show': this.openInfo}" style="height: fit-content; z-index: 120;" #offCanva>
  <div class="header-info"tabindex="-1" [ngClass]="{'show': openInfo}"  (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd()">
    <div></div>
  </div>
  <div class="offcanvas-body">
    <div class="content-offCanva">
        <span class="title-offCanva">{{ titleInfo}}</span>
        <div class="partial-usage-visual" *ngIf="showPartialUsageVisual">
            <div class="visual-box total">
                <span>Saldo Total</span>
                <span class="value">{{ user.cashback | currency:'BRL' }}</span>
            </div>
            <div class="visual-arrow">
                <i class="fa-solid fa-arrow-right-long"></i>
            </div>
            <div class="visual-box used">
                <span style="color: green">Vai usar</span>
                <span class="value">{{ selectedOption.value | currency:'BRL' }}</span>
            </div>
        </div>
        <span class="info-offCanva">{{ textinfo }}</span>
    </div>
    <div class="button-offCanva">
      <button (click)="closeOffCanvas()">Ok, Entendi</button>
    </div>
  </div>
</div>



